import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IResults } from '@results/store/results.state';
import { selectContextCore } from '@store/context/context.selector';
import { selectRouterQueryParams } from '@store/router/router.selector';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MbIcon, MbChips, MbChip } from '@am/moebius';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'am-applied-filter-list',
  standalone: true,
  styleUrls: ['./applied-filters-list.component.scss'],
  templateUrl: './applied-filters-list.component.html',
  imports: [MbIcon, MbChips, MbChip, CurrencyPipe],
})
export class AppliedFiltersListComponent implements OnInit, OnDestroy {
  @Input()
  public appliedFilters: any;
  @Input()
  public isMobile = false;
  @Output()
  public filterRemoved: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public allFiltersRemoved: EventEmitter<void> = new EventEmitter<void>();
  public unSubscribe$ = new Subject<void>();
  public filterNameValue: string;
  public params = {};
  public priceRange: { min: number | null; max: number | null };
  public queryParams: any;
  public currencyCode: string;

  constructor(private store$: Store<IResults>) {}

  public ngOnInit() {
    this.store$
      .pipe(select(selectRouterQueryParams), takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.queryParams = data;
      });
    this.store$
      .pipe(select(selectContextCore), takeUntil(this.unSubscribe$))
      .subscribe((context) => {
        this.currencyCode = context.currency.code;
      });
  }

  public trackByItems(index) {
    return index;
  }

  public changeFilter(type, item) {
    this.filterRemoved.emit({ type, item });
  }

  public ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.unsubscribe();
  }
}
